module.exports = __webpack_public_path__ + "static/media/barbarian.6a0554c6.gif";